import { render, staticRenderFns } from "./query-type-selector.vue?vue&type=template&id=3bb55998&scoped=true"
import script from "./query-type-selector.vue?vue&type=script&lang=js"
export * from "./query-type-selector.vue?vue&type=script&lang=js"
import style0 from "./query-type-selector.vue?vue&type=style&index=0&id=3bb55998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb55998",
  null
  
)

export default component.exports